import { useState, useEffect } from "react";
import * as DialogPrimitive from "@radix-ui/react-dialog";
import { toast } from "sonner";
import { Eye, X } from "lucide-react";
import { fileUrl } from "../../lib/fileUrl";

/**
 * Pulsante + anteprima documento a schermo intero.
 * Usa un Dialog Radix ANNIDATO: Radix gestisce lo stack dei layer, quindi la
 * chiusura (X, click fuori o Esc) chiude SOLO questa anteprima e mai il dialog
 * sottostante (es. creazione lotto).
 */
export const ImagePreview = ({ path, previewUrl, label = "Vedi anteprima", className = "" }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(false);
  const src = previewUrl || fileUrl(path);
  useEffect(() => { setError(false); }, [src]);
  if (!path) return null;
  return (
    <DialogPrimitive.Root open={open} onOpenChange={setOpen}>
      <DialogPrimitive.Trigger asChild>
        <button
          type="button"
          onClick={() => toast.dismiss()}
          data-testid="fattura-anteprima-btn"
          className={`inline-flex items-center justify-center gap-1.5 px-3 h-9 rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold active:scale-95 transition-colors ${className}`}
        >
          <Eye className="h-4 w-4" /> {label}
        </button>
      </DialogPrimitive.Trigger>
        <DialogPrimitive.Portal>
          <DialogPrimitive.Content
            className="fixed inset-0 z-[80] bg-black/95 flex items-center justify-center p-4 focus:outline-none"
            onClick={() => setOpen(false)}
            data-testid="fattura-preview-overlay"
          >
            <DialogPrimitive.Title className="sr-only">Anteprima documento</DialogPrimitive.Title>
            <DialogPrimitive.Description className="sr-only">Foto fattura allegata al lotto.</DialogPrimitive.Description>
            <DialogPrimitive.Close asChild>
              <button
                type="button"
                onClick={(e) => e.stopPropagation()}
                className="absolute top-4 right-4 w-12 h-12 rounded-full bg-white/15 hover:bg-white/25 text-white flex items-center justify-center"
                data-testid="fattura-preview-close"
                aria-label="Chiudi anteprima"
              >
                <X className="h-6 w-6" />
              </button>
            </DialogPrimitive.Close>
            {error ? (
              <p className="text-center text-white" role="alert" data-testid="fattura-preview-error">Anteprima non disponibile. Riprova il caricamento della foto.</p>
            ) : (
              <img src={src} alt="Anteprima documento" data-testid="fattura-preview-image"
                className="max-w-full max-h-full object-contain rounded-xl"
                onError={() => setError(true)} onClick={(e) => e.stopPropagation()} />
            )}
          </DialogPrimitive.Content>
        </DialogPrimitive.Portal>
    </DialogPrimitive.Root>
  );
};

export default ImagePreview;
